import React from 'react'

import { jobs, job, unexpirableJobs } from '../../lib/Jobs'
import { Table, Button } from 'react-bootstrap';
import Loading from '../../components/Loading'
import Job from '../../lib/Job'
import User from '../../lib/User';
import IssueDashboard from './IssueDashboard'
import { EditModal, NotificationModal, EditNumberModal, ApproveJobModal, CancelJobModal } from '../../components/Modals'
import JobTable from './JobTable';

class ApplicantsPopup extends React.Component {
    state = {
        loading: true,
        applicants: [],
    }

    getJob = async() => {
        const jobObject = await job(this.props.swipecast_job_id);
        this.setState({
            loading: false,
            applicants: jobObject.job.applicants.map((applicant) => new User(applicant))
        })

    }

    componentDidMount() {
        this.getJob()
    }

    getStyles() {
        return {
            container: {
                position: 'fixed',
                width: '100%',
                top: '0px',
                left: '0px',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                padding: '100px'
            },
            inner_container: {
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
                flexDirection: 'column',
                overflowY: 'scroll',
                alignItems: 'center',
            },

        }
    }
    render() {
        var styles = this.getStyles()
        return (
            <div style = {styles.container}>
                <div style = {styles.inner_container}>
                    <Button onClick = {(e)=>{this.props.hideModal()}} >Close x</Button>
                    <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>Applicant</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.applicants.map((applicant, index)=>{
                                return (
                                    <tr key= {index} >
                                        <td>{applicant.user.first_name + ' ' + applicant.user.last_name}</td>
                                         <td>{applicant.status}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
                </div>
            </div>)
    }
}

// TODO continue refactoring this component by moving the filtration entirely from client to the API
class Jobs extends React.Component {
    state = {
        loading: true,
        jobs: [],
        unexpirable_jobs: [],
        current_job_id: null,
        showing_applicants_popup: null,
        current_bucket: 'hidden',
        page: 0,
        has_more: false,
    }

    getJobs = async ({ scope = this.state.current_bucket, perPage } = {}) => {
        const { page } = this.state
        const newPage = page + 1
        const { jobs: jobList, pagy } = await jobs({ perPage, newPage, scope });
        const hasMore = pagy.page < pagy.pages

        this.setState((prevState) => ({
            ...!this.isIssueTab(scope) && { count: pagy.count },
            page: newPage,
            loading: false,
            has_more: hasMore,
            jobs: [...prevState.jobs, ...(jobList || []).map((job) => new Job(job))]
        }))
    }

    // TODO add backend query logic to support getJobs method for expired jobs
    getUnexpirableJobs = async (scope = this.state.current_bucket) => {
        const jobList = await unexpirableJobs();
        if (!jobList.jobs) return

        this.setState({
            ...!this.isIssueTab(scope) && { count: jobList.jobs.length },
            page: 1,
            loading: false,
            has_more: false,
            unexpirable_jobs: jobList.jobs.map((job) => new Job(job))
        })
    }

    loading() {
        if (this.state.loading) {
            return <Loading />
        } else {
            return null
        }
    }

    componentDidUpdate(_, prevState) {
        if (prevState.current_bucket !== this.state.current_bucket) {
            this.setState(
                () => ({ count: null, page: 0, has_more: false, loading: true, jobs: [] }),
                () => {
                    if (this.state.current_bucket === 'expired') {
                        return this.getUnexpirableJobs()
                    }
                    // TODO move this to a single query. Remove frontend filtration enrtirely
                    if (this.isIssueTab()) {
                        // cant paginate for now, because a mess with concatenating with UnexpirableJobs. It should be a single query
                        this.getJobs({ scope: this.state.current_bucket, perPage: 1000 })
                        return this.getUnexpirableJobs()
                    }

                    this.getJobs({ scope: this.state.current_bucket })
                }
            )
        }
    }

    componentDidMount() {
        this.getJobs()
    }

    showEditModal(title, message, saveAction = function() {}) {
        this.refs.modal.show(title, message, saveAction);
    }

    showApplicantListModal(swipecast_job_id) {
        this.setState({
            showing_applicants_popup: true,
            current_job_id: swipecast_job_id
        })
    }

    showNotificationModal(saveAction = function() {}) {
        this.refs.notificationModal.show(saveAction);
    }

    showEditNumberModal(title, subtitle, okText, number, saveAction = function() {}) {
        this.refs.editNumberModal.show(title, subtitle, okText, number, saveAction);
    }

    showApproveJobModal(manual_ordering, editorial_tier, commercial_tier, saveAction = function() {}) {
        this.refs.approveJobModal.show(manual_ordering, editorial_tier, commercial_tier, saveAction);
    }

    showCancelJobModal(title, saveAction) {
        this.refs.cancelJobModal.show(title, saveAction);
    }

    confirmWireCheck = (job) => {
      if (window.confirm(`You are about to complete job "${job.project.name}". Confirm?`)) {
        job.update({
          status: 'completedJob',
          'payment_method': 'non-stripe'
        });
        window.location.reload();
      }
    }

    getStyles() {
        return {
            header_button: {
                height: '100px',
                lineHeight: '100px',
                textAlign: 'center',
                cursor: 'pointer'
            },
            header_button_selected: {
                height: '100px',
                lineHeight: '100px',
                textAlign: 'center',
                backgroundColor: '#ccc'
            }
        }
    }

    isIssueTab = (bucket = this.state.current_bucket) => {
        const issueTabs = ['deferred_payments', 'chasing']
        return issueTabs.includes(bucket)
    }

    render() {
        const self = this;
        var styles = this.getStyles();
        const { count } = this.state
        const fields = [
          {id: 'approved', title: 'Is client approved?'},
          {id: this.state.current_bucket == 'expired'? 'unexpire': 'approve', title: this.state.current_bucket == 'expired'? 'Unexpire': 'Approve'},
          {id: 'notification', title: 'Send Notification'},
          {id: 'name', title: 'Project Name + SF Link'},
          {id: 'hidden', title: 'Hidden ?'},
          {id: 'approved_by', title: 'Approved By'},
          {id: 'type', title: 'Type'},
          {id: this.state.current_bucket == 'expired'? 'previous_status': 'status', title: this.state.current_bucket == 'expired'? 'Previous Status': 'Status'},
          {id: 'rate', title: 'Rate'},
          {id: 'total_rate', title: 'Total Rate'},
          {id: 'client_admin', title: 'Client'},
          {id: 'talent', title: 'Talent'},
          {id: 'bank_info', title: 'Talent Bank Info Included'},
          {id: 'looking_for', title: 'Looking For'},
          {id: 'looking_for_details', title: 'Looking For Details (filters)'},
          {id: 'project_type', title: 'Project Type'},
          {id: 'posted_date', title: 'Date Posted'},
          {id: 'city', title: 'City'},
          {id: 'job_dates', title: 'Job Dates'},
          {id: 'package_link', title: 'Package Link'},
          {id: 'third_party_link', title: 'Third Party Link'},
          {id: 'applicants_list', title: 'Applicants List'},
          {id: 'manual_ordering', title: 'Manual Ordering'},
          {id: 'internal_notes', title: 'Internal Notes'},
          {id: 'edit_internal_notes', title: 'Edit Internal Notes'},
          {id: 'notes', title: 'Notes'},
          {id: 'engineering_details', title: 'Engineering Details'}
        ];
        var options = [
        {
            id: 'deferred_payments',
            title: 'Deferred Payments'
        }, {
            id: 'chasing',
            title: 'Chasing'
        }, {
            id: 'hidden',
            title: "Not Approved",
        }, {
            id: 'approved_waiting',
            title: 'Approved, waiting for applicants'
        }, {
            id: 'pending',
            title: 'Pending (waiting on payment, etc)'
        }, {
            id: 'card_failed',
            title: 'Card charge failed'
        }, {
            id: 'confirmed',
            title: 'Confirmed'
        }, {
            id: 'expired',
            title: 'Expired'
        }, {
            id: 'all',
            title: 'All Active Jobs'
        }];

        return (
            <div>
              <Table striped bordered condensed hover>
                <tbody>
                  <tr>
                  {
                    options.map((option,index)=>{
                      const isSelected = this.state.current_bucket == option.id
                      return (
                        <th
                          key={option.id}
                          onClick = {()=>{this.setState({current_bucket: option.id})}}
                          style={isSelected ? styles.header_button_selected : styles.header_button}
                        >
                            {isSelected && count ? `${option.title}(${count})` : option.title }
                        </th>
                      )
                    })
                  }
                  </tr>
                </tbody>
              </Table>
              {
                this.isIssueTab() &&
                <IssueDashboard
                  loading={this.state.loading}
                  jobs={this.state.jobs}
                  bucket={this.state.current_bucket}
                  hasMore={this.state.has_more}
                  unexpirable_jobs={this.state.unexpirable_jobs}
                  confirmWireCheck = {this.confirmWireCheck}
                  showEditModal = {self.showEditModal.bind(self)}
                />
              }
              {
                !this.isIssueTab() &&
                <JobTable
                  hasMore={this.state.has_more}
                  loading={this.state.loading}
                  getJobs={this.getJobs}
                  jobs={this.state.current_bucket === 'expired' ? this.state.unexpirable_jobs : this.state.jobs}
                  showEditModal = {self.showEditModal.bind(self)}
                  showApplicantListModal = {self.showApplicantListModal.bind(self)}
                  showNotificationModal = {self.showNotificationModal.bind(self)}
                  showEditNumberModal = {self.showEditNumberModal.bind(self)}
                  showApproveJobModal = {self.showApproveJobModal.bind(self)}
                  showCancelJobModal = {self.showCancelJobModal.bind(self)}
                  confirmWireCheck = {this.confirmWireCheck}
                  fields = {fields}
                />
              }
              <EditModal
                ref="modal"
                title="Error"
                message=""
                buttonText="Close"
              />
              <NotificationModal
                ref="notificationModal"
                buttonText="Close"
              />
              <EditNumberModal
                ref="editNumberModal"
                buttonText="Close"
              />
              <ApproveJobModal
                ref="approveJobModal"
                buttonText="Close"
              />
              <CancelJobModal
                ref="cancelJobModal"
                buttonText="Close"
              />
              {
                  this.state.showing_applicants_popup == true &&
                  <ApplicantsPopup
                    hideModal = {()=>{this.setState({showing_applicants_popup: false})}}
                    swipecast_job_id = {this.state.current_job_id}
                  />
              }
            </div>
        )
    }
}

export default Jobs;
